import { API, CONSTANTS } from 'config';

function ReportService($http, $q, $resource, $tszToast, $mdDialog, $base64, FileSaver, Blob) {

  'ngInject';

  const ReportResource = $resource(API.REPORTS, { report_id: '@id' }, {
    get: {
      method: 'GET',
    },
    download: {
      method: 'GET',
      headers: {
        accept: 'application/pdf',
      },
      responseType: 'arraybuffer',
      url: `${API.REPORTS}/pdf`,
      transformResponse: (data) => {
        let pdf;
        if (data) {
          pdf = new Blob([data], {
            type: 'application/pdf',
          });
        }
        return {
          response: pdf,
        };
      },
    },
    generate: {
      method: 'POST',
      url: `${API.REPORT.GENERATE}`,
    },
    verify_csv: {
      method: 'GET',
      url: `${API.REPORT.VERIFY_CSV}`,
    },
    download_csv: {
      method: 'GET',
      url: API.REPORT.DOWNLOAD_CSV,
    },
    create: {
      method: 'POST',
    },
    duplicate: {
      method: 'POST',
      url: API.REPORT.DUPLICATE,
    },
    update: {
      method: 'PUT',
    },
    delete: {
      method: 'DELETE',
    },
    list: {
      method: 'GET',
      isArray: true,
    },
    company_reports: {
      method: 'GET',
      url: API.COMPANY.REPORTS,
      isArray: true,
    },
    get_calculated_reports: {
      method: 'GET',
      url: API.COMPANY.CALCULATED_REPORTS,
      isArray: true,
    },
    get_report_price: {
      method: 'POST',
      url: `${API.COMPANY.REPORTS}/price`,
    },
    get_price: {
      method: 'POST',
      url: `${API.REPORT.PRICE}`,
    },
    calculate: {
      method: 'POST',
      url: '/api/reports/calculate',
    },
  });

  return {
    get: (reportId) => ReportResource.get({ report_id: reportId }).$promise,
    create: (report) => ReportResource.create(report).$promise,
    update: (report) => ReportResource.update(report).$promise,
    delete: (reportId) => ReportResource.delete({ report_id: reportId }).$promise,
    duplicate: (reportId) => ReportResource.duplicate({ id: reportId }).$promise,
    list: () => ReportResource.list().$promise,
    company_reports: (companyId) => ReportResource.company_reports({ id: companyId }).$promise,
    get_calculated_reports: (companyId) =>
      ReportResource.get_calculated_reports({ id: companyId }).$promise,
    calculate: (report) => ReportResource.calculate({}, report).$promise,
    // calculate: (report) => $http.post(`${API.REPORTS.CALCULATE}`, report),
    generate: (reportId) => ReportResource.generate({ id: reportId, report_id: reportId }).$promise,
    verify_csv: (csv) => ReportResource.verify_csv({ csv }).$promise,
    download_csv: (csv) => ReportResource.download_csv({ csv }).$promise,

    export: (report) => {
      const data = new Blob([$base64.encode(JSON.stringify(report, null, '\t'))], { type: 'text/plain;charset=utf-8' });
      FileSaver.saveAs(data, `${report.name}.tsz`);
    },

    download: (report) => {
      ReportResource.download({ report_id: report.id }).$promise
      .then((blob) => {
        // const data = new Blob([response.data], { type: 'application/pdf;' });
        FileSaver.saveAs(blob.response, `${report.name}.pdf`);
      }).catch(() => {
        $tszToast.showError('Se ha producido un error al descargar el informe');
      });
    },

    getPrice1: (report) => {
      if (report.building_usage && report.design_type && report.area) {
        const bu = CONSTANTS.BUILDING_USAGE[report.building_usage].value;
        const pt = CONSTANTS.PROJECT_TYPE[report.design_type].value;
        const area = report.area;
        const minPrice = CONSTANTS.PROJECT_TYPE[report.design_type].min_price;

        let price = bu * pt * area;
        if (price < minPrice) {
          price = minPrice;
        }
        return price;
      }
      return 0;
    },

    getPrice: (companyId, report) => ReportResource.get_report_price(
      { id: companyId },
      {
        area: report.area,
        buildingUsage: report.building_usage,
        projectType: report.design_type,
      }).$promise,

    getBasePrice: (report) => ReportResource.get_price(
      {
        area: report.area,
        buildingUsage: report.building_usage,
        projectType: report.design_type,
      }).$promise,

    deleteAction: (report, ev, callback) => {

      const confirm = $mdDialog.confirm()
            .clickOutsideToClose(true)
            .title('Estás seguro de que quieres eliminar este informe?')
            .textContent(`Esta operación eliminará de forma irreversible el informe "${report.name}"`)
            .ariaLabel('Confirmar eliminación informe')
            .targetEvent(ev)
            .ok('Eliminar')
            .cancel('Cancelar');

      $mdDialog.show(confirm)
      .then(() => {
        ReportResource.delete({ report_id: report.id }).$promise
        .then(() => {
          $tszToast.showSuccess(`El informe "${report.name}" ha sido eliminado`);
          // scope.$emit('report_deleted', report.id);
          callback(report.id);
        }).catch((err) => {
          console.error(err.message);
          $tszToast.showError(`Se ha producido un error al eliminar el informe "${report.name}"`);
        });
      });
    },
  };
}

export default ReportService;



// WEBPACK FOOTER //
// ./src/services/Report.js